import MxTypography from "@rf-l1/MxTypography";

interface MxDetailCardAgencyAgencyProps {
  name: string;
}

const MxDetailCardAgentAgency = (props: MxDetailCardAgencyAgencyProps) => {
  return (
    <MxTypography
      color="grey.700"
      variant="caption"
      fontWeight={400}
      autoCopy
      removeAutoCopyStyles
    >
      {props.name}
    </MxTypography>
  );
};
export default MxDetailCardAgentAgency;
